module.exports = __webpack_public_path__ + "Nazara-2ee18c0a.webp";